import { eBieuDoActionsObj } from "../../action-types/bieu-do/IBieuDoActionTypes";
import { generateActions } from "../generateActions";

export const bieuDoActions = {
  ...generateActions(eBieuDoActionsObj, "BIEU_DO"),
};
